import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'pgh-skip-test',
  templateUrl: './skip-test-modal.component.html',
  styleUrls: ['./skip-test-modal.component.scss'],
})
export class SkipTestModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<SkipTestModalComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
  ) {}

  public message1: string;
  public message2: string;
  public message3: string;
  public title: string;
  public cancelButtonTitle: string;
  public confirmButtonTitle: string;

  ngOnInit() {

    this.title = this.dialogData.title;
    this.message1 = this.dialogData.message1;
    this.message2 = this.dialogData.message2;
    this.message3 = this.dialogData.message3;
    this.cancelButtonTitle = this.dialogData.cancelButtonText;
    this.confirmButtonTitle = this.dialogData.confirmButtonText;

  }

  onCancelClicked() {
    this.dialogRef.close({ data: 'cancel' });
  }

  onContinueClicked() {
    this.dialogRef.close({ data: 'success' });
  }
}
